<template>
    <div>
        <!-- <div>
            筛选 : &nbsp;&nbsp;&nbsp;&nbsp;
            <el-select v-model="dateValue" placeholder="请选择" size="small">
                <el-option v-for="item in dateOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div> -->
        <div>
            <el-table :data="data">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="expName" label="实验报告"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status==0" type="info" size="small">未提交</el-tag>
                        <el-tag v-else-if="scope.row.status==1" type="success" size="small">已提交</el-tag>
                        <el-tag v-else-if="scope.row.status==2" type="warning" size="small">已批阅</el-tag>
                        <el-tag v-else-if="scope.row.status==3" type="danger" size="small">被驳回</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="成绩"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="handSubmit(scope.row)" size="mini">提交</el-button>
                        <el-button plain type="primary" size="mini">下载报告</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {}
    },
    props:{
        data:{
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods:{
        handSubmit(row){
            this.$emit('submitReport',row)
        }
    }
}
</script>